/**
 * WorkOS AuthKit configuration. Both values come from the environment — there is no token-entry
 * fallback any more, so a build without a client id cannot authenticate anyone and
 * `WorkosAuthProvider` says so rather than rendering a shell that can never load data.
 */
export const WORKOS_CLIENT_ID = process.env.REACT_APP_WORKOS_CLIENT_ID

/**
 * Optional — AuthKit defaults to its own host. Normalised to `undefined` because the env files
 * ship the key blank, and an empty string would be passed through as a real hostname.
 */
export const WORKOS_API_HOSTNAME = process.env.REACT_APP_WORKOS_API_HOSTNAME || undefined
